import { COOKIE_NAME, COOKIE_EXPIRES } from '../constants';

export function setOnboardingCloseCookie() {
  const date = new Date(Date.now() + COOKIE_EXPIRES);
  document.cookie = `${COOKIE_NAME}=meow; domain=.cian.ru; expires=` + date.toUTCString();
}
